<template>
	<div>
		<ja-input
			v-model="careerClusterData.name"
			:disabled="isObserver"
			class="input-name"
			:label="$t('careerCluster')"
			:name="$t('careerCluster')"
		></ja-input>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-question__careers " @click="sortColumn('name')">
						<div class="th-sort">
							<span> {{ $t('cmsCareers') }}</span>
							<span v-if="sortedColumn === 'name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td>{{ row.name }}</td>
					<td class="td-center">
						<button
							class="action-button"
							:disabled="isObserver"
							@click="editRow(row)"
						>
							<svgicon name="pencil"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<div class="container-buttons save">
			<ja-button
				name="save"
				class="small outlined"
				:disabled="isObserver"
				@click.native="saveCareers"
				>{{ $t('save') }}</ja-button
			>
			<ja-button name="cancel" class="small" @click.native="cancel">{{
				$t('cancel')
			}}</ja-button>
		</div>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="data.length"
			@changePage="setAllPage"
		></ja-pagination>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import Input from '@/components/ui/form/Input';
import Button from '@/components/ui/Button';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaPagination: Pagination,
		jaButton: Button,
		jaInput: Input
	},
	props: {
		data: {
			type: Object,
			required: true
		},
		isObserver: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			careerClusterData: null,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			currentPage: 1,
			itemsPerPage: 15,
			interestNameIndex: 0
		};
	},
	computed: {
		displayedData() {
			let filteredData = this.data.cmsCareers;

			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					const fieldA = a[this.sortedColumn].toLowerCase();
					const fieldB = b[this.sortedColumn].toLowerCase();
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
			const start = (this.currentPage - 1) * this.itemsPerPage;
			filteredData = filteredData.slice(start, start + this.itemsPerPage);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	created() {
		this.careerClusterData = this.data;
	},
	methods: {
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			row.careerClusterName = this.data.name;
			this.$emit('editRow', row);
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		saveCareers() {
			this.$emit('saveCareerCluster', this.careerClusterData);
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.th-question {
	&__careers {
		width: 90%;
	}
	&__actions {
		width: 10%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}

.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.action-button:disabled {
	cursor: not-allowed;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

.container-buttons {
	margin: 15px 0 10px 0;
	display: flex;
	align-items: center;
	gap: 20px;
	justify-content: flex-end;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
